<div>
    <hub-modal-header headerText="{{ 'bikeshop.coupons.add_a_coupon_code' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">
    <div class="input-control">
        <hub-input  [autofocus]="true"
            [(ngModel)]="couponCode" (input)="onCouponCodeChange()" [required]="true"></hub-input>
    </div>
    <div *ngIf="couponCodeError" class="error-message">
        <span>{{ couponCodeError }}</span>
    </div>
    <div *ngIf="!couponCodeError && couponCodeValid" class="success-message">
        <span>{{ 'bikeshop.coupons.coupon_code_valid' | translate }}</span>
    </div>
</div>
<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [text]="'general.apply' | translate" [style]="'secondary'" [disabled]="!couponCode || !couponCodeValid"
            [size]="'xl'" (buttonClick)="applyCoupon()"></hub-button>
    </div>
    <div class="short-cut-container">
        <span><daz-icon [name]="'enter'" [size]="'18px'" [color]="'#6B728C'"></daz-icon></span>{{'bikeshop.workshop.jobcard.quote.to_save_and_close' | translate}}
    </div>
</div>